import { CommandProps, Extension } from "@tiptap/vue-3";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    paragraphIndent: {
      toggleIndent: () => ReturnType;
    };
  }
}

export default Extension.create({
  name: "paragraphIndent",
  addGlobalAttributes() {
    return [
      {
        types: ["paragraph"],
        attributes: {
          indent: {
            default: false,
            attributes: {
              indent: {
                default: false,
                parseHTML: (element) => {
                  return {
                    indent: element.hasAttribute("data-indent"),
                  };
                },
                renderHTML: (attributes) => {
                  if (!attributes.indent) {
                    return {};
                  }
                  return {
                    "data-indent": "true",
                  };
                },
              },
            },
          },
        },
      },
    ];
  },
  addCommands() {
    return {
      toggleIndent:
        () =>
        ({ commands, state }: CommandProps) => {
          commands.updateAttributes("paragraph", {
            indent: !state.selection.$from.parent.attrs.indent,
          });
        },
    };
  },
});
